import React, { Component, Fragment } from 'react';
import ItemFlight from './components/ItemFlight';
import StepHeader from '../../common/StepHeader';
import axios from 'components/AppRequest';
import { connect } from 'react-redux';
import { setDepartureFlight, setReturnFlight } from 'components/actions/bookingActions';
import FlightsValidation from '../utils/FlightsValidation';
import withRouter from 'components/components/common/withRouter';
import BookingRedirect from '../utils/BookingRedirect';
import { Error } from 'components/common/Form.js';
import {
  fetchPriceList,
  fetchCustomerAddresses,
  fetchBusStops
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import T from 'components/common/translations/Translate';
import NoConnection from 'components/components/common/NoConnection';

class Flights extends Component {

  state = {
    departureFlights: [],
    departureCommunicate: null,
    returnFlights: [],
    returnCommunicate: null,
    isLoading: true,
    errors: {},
    noConnection: false,
  }

  dateToParam(dateObj) {
    if (dateObj.value) {
      return dateObj.value.format("DD-MM-YYYY");
    } else {
      return null;
    }
  }

  componentDidMount() {
    new BookingRedirect(this.props).canViewFlights();
    this.fetchData();
  }

  fetchData = () => {
    var params = {
      data: {
        startDate: this.dateToParam(this.props.startDate),
        endDate: this.dateToParam(this.props.endDate),
        airportFrom: this.props.airportFrom,
        airportTo: this.props.airportTo
      }
    };
    axios.get('/pwa/reservation/flights', { params: params })
      .then(response => {
        this.setState(
          {
            departureFlights: response.data.departureFlights,
            departureCommunicate: response.data.departureCommunicate,
            returnFlights: response.data.returnFlights,
            returnCommunicate: response.data.returnCommunicate,
            isLoading: false,
            noConnection: false
          }
        );
        this.props.fetchPriceList();
        this.props.fetchBusStops();
        this.props.fetchCustomerAddresses();
      })
      .catch(error => {
        if (error.response) {
          console.log('app error', error)
        } else {
          this.setState({ noConnection: true });
          console.log('error', error)
        }
      });
  }

  handleClickDepartueFlight = (flight) => {
    this.props.setDepartureFlight(flight);
  }

  handleClickReturnFlight = (flight) => {
    this.props.setReturnFlight(flight);
  }

  goNext = (e) => {
    e.preventDefault();
    //reset errors
    this.setState({ errors: {} });

    var validateObject = new FlightsValidation(this.props);
    if (validateObject.isValidForm()) {
      TransHelper.redirect(this.props, 'routes.url.map');
    }
    else {
      this.setState({ errors: validateObject.getFieldsErrors() });
    }
  }

  backRedirect = () => {
    if (this.props.startFromBooking) {
      return this.props.childrenNumber === 0 ? 'routes.url.booking' : 'routes.url.kidsSafety'
    } else {
      var home = TransHelper.translateRoute(this.props.locale, 'routes.url.home');
      return this.props.childrenNumber === 0 ? home : 'routes.url.kidsSafety'
    }
  }

  trans = (key) => {
    return TransHelper.translate(this.props.locale, key);
  }

  render() {
    const { childrenNumber, endDate } = this.props;
    const isOneway = endDate.value !== null ? true : false;
    var backToBookingLabel = this.trans('content.common.backToBooking');
    var editKidsSafety = this.trans('content.common.backToBooking');
    return (
      <div className="content" style={{ padding: 0 }}>
        <div className="grid-layout grid-layout--vh">
          <div className="grid-layout__item grid-layout__item--desc grid-layout__item--middle">
            <div className="content__desc content__desc--static">
              <StepHeader
                link={this.backRedirect()}
                linkTitle={childrenNumber === 0 ? backToBookingLabel : editKidsSafety}
                step={childrenNumber === 0 ? 1 : 2}
                maxSteps={5}
                title={this.trans('content.bookingStep2.chooseFlyOut')}
                isAnim={true}
                booking
              />

              {this.state.noConnection
                ?
                <NoConnection loadContent={this.fetchData} />
                :
                <form>
                  <fieldset>
                    <legend className="visuallyhidden">Select Flight</legend>

                    {
                      this.state.departureCommunicate &&
                      <p className="message message--error">{this.state.departureCommunicate}</p>
                    }

                    {
                      this.state.isLoading &&
                      <i className="loader" />
                    }

                    {
                      this.state.isLoading == false &&
                      <ul className="list-flights">
                        {this.state.departureFlights.map((e, i) => {
                          var active = false;
                          if (this.props.departureFlight) {
                            active = this.props.departureFlight.id === e.id;
                          }
                          return (
                            <ItemFlight
                              active={active}
                              flightObj={e}
                              key={i}
                              handleChange={this.handleClickDepartueFlight}
                            />
                          );
                        })}
                      </ul>
                    }

                    <Error
                      error={this.state.errors.departure}
                      css={{ margin: '-15px 0 35px 6px' }}
                    />

                    {
                      isOneway &&
                      <header className="head mb-20">
                        <h3>{this.trans('content.bookingStep2.chooseFlyBack')}</h3>
                      </header>
                    }

                    {
                      this.state.returnCommunicate &&
                      <p className="message message--error">{this.state.returnCommunicate}</p>
                    }

                    {
                      this.state.isLoading &&
                      <i className="loader" />
                    }

                    {
                      this.state.isLoading == false &&
                      <ul className="list-flights list-flights--back">
                        {this.state.returnFlights.map((e, i) => {
                          var active = false;
                          if (this.props.returnFlight) {
                            active = this.props.returnFlight.id === e.id;
                          }
                          return (
                            <ItemFlight
                              active={active}
                              flightObj={e}
                              key={i}
                              handleChange={this.handleClickReturnFlight}
                            />
                          );
                        })}
                      </ul>
                    }
                    <Error
                      error={this.state.errors.return}
                      css={{ margin: '-15px 0 35px 6px' }}
                    />
                    <button
                      className="button button--outline button--expand"
                      onClick={this.goNext}
                    >
                      {this.trans('content.common.next')}
                    </button>
                  </fieldset>
                </form>
              }
            </div>
          </div>
          <div className="grid-layout__item grid-layout__item--info" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    startDate: state.booking.startDate,
    endDate: state.booking.endDate,
    airportFrom: state.booking.airportFrom,
    airportTo: state.booking.airportTo,
    returnFlight: state.booking.returnFlight,
    departureFlight: state.booking.departureFlight,
    childrenNumber: state.booking.childrenNumber,
    startFromBooking: state.booking.startFromBooking,
    isLogged: state.app.isLogged
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      setDepartureFlight,
      setReturnFlight,
      fetchPriceList,
      fetchCustomerAddresses,
      fetchBusStops
    }
  )(Flights)
);
